import React, { useState } from "react";
import { Mail, Building2, GraduationCap, MapPin, Send, ExternalLink, MessageCircle, Linkedin, Globe, Briefcase } from "lucide-react";
import { Panel, Overline } from "../common/Panel";
import { sendContact } from "../../lib/api";
import { toast } from "sonner";

const inputCls = "w-full bg-[var(--surface2)] border border-[var(--bd)] rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-[var(--accent)] transition-colors";

const INFO = [
  { icon: Mail, label: "Email", value: "henockhnk092@gmail.com" },
  { icon: Building2, label: "Institution", value: "Cape Peninsula University of Technology (CPUT)" },
  { icon: GraduationCap, label: "Supervisor", value: "M. Ratshitanga" },
  { icon: MapPin, label: "Location", value: "Cape Town, South Africa" },
];

const QUICK = [
  { icon: Globe, label: "Portfolio", href: "https://parkade-stitch-site.pages.dev" },
  { icon: Briefcase, label: "Book Services", href: "https://wa.me/27754531797" },
  { icon: ExternalLink, label: "Live Dashboard", href: "#" },
  { icon: MessageCircle, label: "WhatsApp", href: "https://wa.me/27754531797" },
  { icon: Linkedin, label: "LinkedIn", href: "https://linkedin.com" },
];

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Please fill in all fields"); return; }
    setBusy(true);
    try {
      await sendContact(form);
      toast.success("Message sent! Henock will get back to you soon.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.success("Message sent! Henock will get back to you soon.");
      setForm({ name: "", email: "", message: "" });
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6">
      <div>
        <Overline>Get in Touch</Overline>
        <h2 className="font-heading font-bold text-2xl tracking-tight mt-1">Contact</h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Panel className="p-6">
          <Overline>Send a Message</Overline>
          <form onSubmit={submit} className="mt-4 space-y-4" data-testid="contact-form">
            <input data-testid="contact-name" className={inputCls} placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <input data-testid="contact-email" type="email" className={inputCls} placeholder="Your email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <textarea data-testid="contact-message" rows={5} className={inputCls} placeholder="Your message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
            <button type="submit" disabled={busy} data-testid="contact-submit" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-[var(--accent)] text-black text-sm font-medium active:scale-95 transition-transform disabled:opacity-60">
              <Send size={15} /> {busy ? "Sending…" : "Send Message"}
            </button>
          </form>
        </Panel>

        <div className="space-y-4">
          <Panel className="p-6">
            <Overline>Contact Info</Overline>
            <div className="mt-4 space-y-3">
              {INFO.map(({ icon: Icon, label, value }) => (
                <div key={label} className="flex items-start gap-3" data-testid="contact-info-item">
                  <div className="w-9 h-9 rounded-md bg-[var(--accent-soft)] text-[var(--accent)] flex items-center justify-center shrink-0"><Icon size={16} /></div>
                  <div>
                    <div className="text-[10px] uppercase tracking-wider text-[var(--t2)]">{label}</div>
                    <div className="text-sm font-mono">{value}</div>
                  </div>
                </div>
              ))}
            </div>
          </Panel>

          <Panel className="p-6">
            <Overline>Quick Links</Overline>
            <div className="grid grid-cols-2 gap-2 mt-4">
              {QUICK.map(({ icon: Icon, label, href }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer" data-testid={`quick-${label.toLowerCase().replace(/\s/g, "-")}`} className="flex items-center gap-2 px-3 py-2.5 rounded-md bg-[var(--surface2)] border border-[var(--bd)] text-sm hover:border-[var(--accent)] transition-colors">
                  <Icon size={15} className="text-[var(--accent)]" /> {label}
                </a>
              ))}
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
}
